export default "__VITE_ASSET__BnkBFDVv__"